module.exports = __webpack_public_path__ + "img/upload_qzg.d358ca68.png";